module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app1"
    }
  }, [_c('div', [_c('loading', {
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": 'vux-pop-' + (_vm.direction === 'forward' ? 'in' : 'out')
    }
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-c3c8146a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vux-loader@1.1.2@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.1.2@vux-loader/src/template-loader.js!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 246
// module chunks = 28